import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@krea/shared/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-white shadow",
        success: "border-transparent bg-mint-500 text-white shadow",
        secondary: "border-transparent bg-gray-100 text-gray-900",
        destructive:
          "border-transparent bg-red-100 text-black shadow",
        outline: "text-gray-900",
        warning:
          "border-transparent bg-orange-50 text-orange-500 shadow",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge };
